// GoZeek webapplication

import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Login.css';
import Logo from '../../assets/Logo.svg';
import Logo1 from '../../assets/background_1.webp';
import Logo2 from '../../assets/background_2.webp';
import Logo3 from '../../assets/background_3.webp';
import Logo7 from '../../assets/background_7.webp';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const navigate = useNavigate();

  // Handle form submission
  const handleLogin = async (e) => {
    e.preventDefault();

    try {
      const apiUrl = process.env.REACT_APP_GOZEEK_API_URL;
      // console.log('apiUrl from Webadmin', apiUrl);

      // Fetch the login response
      const response = await fetch(`${apiUrl}/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Platform': 'web',
        },
        credentials: 'include',
        body: JSON.stringify({ username, password }),
      });

      if (response.ok) {
        const data = await response.json();

        // Save user details
        localStorage.setItem(
          'user',
          JSON.stringify({
            fullname: data.user.fullname,
            role_id: data.user.role_id,
            app_id: data.user.app_id,
            user_id: data.user.id,
          })
        );

        setErrorMessage('');
        navigate('/dashboard');
      }
      else {
        const errorData = await response.json();
        setErrorMessage(errorData.message || 'Invalid username or password');
      }
    } catch (error) {
      console.error('Login error:', error);
      setErrorMessage('Something went wrong. Please try again.');
    }
  };

  return (
    <div className="login-container">
      <div className="login-form">
        <h2>Login</h2>
        <form onSubmit={handleLogin}>
          <input
            type="text"
            placeholder="Username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
          // autocomplete="username"
          />
          <input
            type="password"
            placeholder="Password"
            onChange={(e) => setPassword(e.target.value)}
          // autocomplete="current-password"
          />
          <button type="submit">Login</button>
        </form>
        {/* Display error message if there is one */}
        {errorMessage && <p className="error-message">{errorMessage}</p>}
      </div>
      <div className="logo-container">
        <img src={Logo} alt="Logo" className="logo logo-center-left" />
        <img src={Logo1} alt="Background Logo 1" className="logo logo-top-right" />
        <img src={Logo2} alt="Background Logo 2" className="logo logo-top-left" />
        <img src={Logo3} alt="Background Logo 3" className="logo logo-center-left2" />
        <img src={Logo7} alt="Background Logo 4" className="logo logo-bottom-left" />
        <img src={Logo7} alt="Background Logo 5" className="logo logo-bottom-left2" />
        <img src={Logo7} alt="Background Logo 6" className="logo logo-bottom-left3" />
        <img src={Logo7} alt="Background Logo 7" className="logo logo-bottom-left4" />
      </div>
    </div>
  );
};

export default Login;
